module.exports = __webpack_public_path__ + "img/ban_14.0886afab.png";